import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '+255753388226';
  const message = 'Hello Marina Homes! I would like to inquire about your serviced apartments.';
  
  // WhatsApp Click to Chat URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 group flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      {/* WhatsApp Icon */}
      <MessageCircle size={28} className="animate-pulse" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us on WhatsApp
      </span>
      
      {/* Notification Badge (optional - can show "1" for attention) */}
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center animate-bounce">
        1
      </span>
    </a>
  );
};

export default WhatsAppButton;
